import Helper from '@ember/component/helper';

import { service } from '@ember/service';

export default class CssVarHelper extends Helper {
  @service ssr;

  compute([ name ]) {
    if (this.ssr.isSsr || !name) {
      return;
    }
    if (name.slice(0, 2) !== '--') {
      name = '--' + name;
    }
    // TODO this could use requestAnimationFrame to do one getComputedStyle per frame needed
    return getComputedStyle(document.documentElement).getPropertyValue(name);
  }
}
